<template>
  <svg
    id="Refer_a_friend_illustration"
    data-name="Refer a friend illustration"
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="110"
    viewBox="0 0 200 110"
  >
    <path
      id="Path_556"
      data-name="Path 556"
      d="M163.605,402.555c-.453,0-.892,0-1.332.014h0c-2.493.014-5,.028-7.494.057l-6.814.042c-4.887.028-9.774.071-14.661.1-1.487.014-2.961.028-4.434.028-4.8.028-9.619.071-14.421.1q-5.758.043-11.517.071c-2.578.014-5.142.028-7.72.057l-6.134.042-14.421.1c-2.635.014-5.284.028-7.919.057-4.845.028-9.7.071-14.548.1l-11.715.085-7.522.042-6.006.043c-4.845.028-9.7.071-14.548.1-.779,0-1.572.014-2.352.014q-.722-.978-1.4-2c-9-13.472-11.12-29.55-5.185-42.157a35.085,35.085,0,0,1,4.986-7.72,36.9,36.9,0,0,1,5.794-5.525,34.447,34.447,0,0,1,12.452-6.12c.85-.212,1.714-.4,2.592-.538a28.614,28.614,0,0,1,5.751-.368,31.268,31.268,0,0,1,11.007,2.55,56.327,56.327,0,0,1,8,4.25c4.306,2.706,8.4,5.85,12.508,8.669a59.948,59.948,0,0,0,9.505,5.539,24.19,24.19,0,0,0,12.877,2.252,21.082,21.082,0,0,0,3-.567,19.139,19.139,0,0,0,4.675-1.856c4.42-2.536,6.417-6.4,11.134-10.214a34.819,34.819,0,0,1,8.584-5.015c.354-.142.708-.3,1.091-.439a64.483,64.483,0,0,1,11.219-3.159,55.469,55.469,0,0,1,6.7-.836,40.029,40.029,0,0,1,12.409,1.006,27.793,27.793,0,0,1,8.9,3.938,25.539,25.539,0,0,1,2.55,1.969,29.843,29.843,0,0,1,7.21,9.746c5.737,12.14,5.383,29.45-2.8,45.543Z"
      transform="translate(-0.108 -293.603)"
      fill="#00a1aa"
      opacity="0.07"
    />
    <g id="Group_695" data-name="Group 695" transform="translate(0 45.546)" opacity="0.89">
      <path
        id="Path_557"
        data-name="Path 557"
        d="M101.248,409.006c-4.845.028-9.7.071-14.548.1l1.856-57.385a34.448,34.448,0,0,1,12.452-6.12l.241,63.406Z"
        transform="translate(-74.421 -344.679)"
        fill="#267476"
        opacity="0.17"
      />
      <path
        id="Path_558"
        data-name="Path 558"
        d="M8.547,477.777c-9-13.472-11.12-29.55-5.185-42.157a35.087,35.087,0,0,1,4.986-7.72l.2,49.878Z"
        transform="translate(-0.022 -415.321)"
        fill="#267476"
        opacity="0.17"
      />
      <path
        id="Path_559"
        data-name="Path 559"
        d="M382.148,444.358c-4.845.028-9.7.071-14.548.1l1.842-57.357c4.306,2.706,8.4,5.85,12.508,8.669l.2,48.588Z"
        transform="translate(-315.53 -380.301)"
        fill="#267476"
        opacity="0.17"
      />
      <path
        id="Path_560"
        data-name="Path 560"
        d="M244.875,341.65l-5.553,61.692-7.522.043,2.068-64.284a31.582,31.582,0,0,1,11.007,2.55Z"
        transform="translate(-198.967 -339.1)"
        fill="#267476"
        opacity="0.17"
      />
      <path
        id="Path_561"
        data-name="Path 561"
        d="M540.621,530.308l-14.421.1,1.388-43.007a24.189,24.189,0,0,0,12.877,2.252l.156,40.656Z"
        transform="translate(-451.663 -466.392)"
        fill="#267476"
        opacity="0.17"
      />
      <path
        id="Path_562"
        data-name="Path 562"
        d="M821.621,415.021c-4.8.028-9.618.071-14.421.1L809.07,357c.354-.142.708-.3,1.091-.439A64.473,64.473,0,0,1,821.38,353.4l.241,61.621Z"
        transform="translate(-692.858 -351.374)"
        fill="#267476"
        opacity="0.17"
      />
      <path
        id="Path_563"
        data-name="Path 563"
        d="M954.961,409.224c-4.887.028-9.774.071-14.661.1l2.012-62.428a40.03,40.03,0,0,1,12.409,1.006Z"
        transform="translate(-807.103 -345.705)"
        fill="#267476"
        opacity="0.17"
      />
      <path
        id="Path_564"
        data-name="Path 564"
        d="M683.909,414.1l-4.788,53.192c-2.578.014-5.142.028-7.72.057l1.388-43.035c4.406-2.536,6.4-6.4,11.12-10.214Z"
        transform="translate(-576.295 -403.476)"
        fill="#267476"
        opacity="0.17"
      />
      <path
        id="Path_565"
        data-name="Path 565"
        d="M1103.5,394.115l-4.108,45.571h0c-2.493.014-5,.028-7.494.057l1.842-57.343a25.568,25.568,0,0,1,2.55,1.969,29.842,29.842,0,0,1,7.21,9.746Z"
        transform="translate(-937.228 -376.266)"
        fill="#267476"
        opacity="0.17"
      />
    </g>
    <g id="Chair" transform="translate(118.948 65.675)">
      <path
        id="Path_566"
        data-name="Path 566"
        d="M949.311,542.65h-6.332v-7.692h5.156a.792.792,0,0,0,.793-.793v-.17a.792.792,0,0,0-.793-.793h-5.156V504.7h-2.1v28.515h-5.156a.792.792,0,0,0-.793.793v.17a.792.792,0,0,0,.793.793h5.156v7.692H934.55a.852.852,0,0,0-.85.85v.057a.852.852,0,0,0,.85.85H949.3a.852.852,0,0,0,.85-.85v-.057a.835.835,0,0,0-.836-.864Z"
        transform="translate(-930.201 -501.371)"
        fill="#0076a5"
      />
      <g id="Group_696" data-name="Group 696" transform="translate(0 0)">
        <path
          id="Path_567"
          data-name="Path 567"
          d="M912.113,482.4h19.478a1.711,1.711,0,0,1,1.714,1.714v.227a1.711,1.711,0,0,1-1.714,1.714H912.113a1.711,1.711,0,0,1-1.714-1.714v-.227A1.7,1.7,0,0,1,912.113,482.4Z"
          transform="translate(-910.201 -482.23)"
          fill="#fff"
        />
        <path
          id="Path_568"
          data-name="Path 568"
          d="M930.376,485.223H910.9a1.9,1.9,0,0,1-1.9-1.9V483.1a1.9,1.9,0,0,1,1.9-1.9h19.478a1.9,1.9,0,0,1,1.9,1.9v.227A1.9,1.9,0,0,1,930.376,485.223ZM910.9,481.554a1.548,1.548,0,0,0-1.544,1.544v.227a1.548,1.548,0,0,0,1.544,1.544h19.478a1.548,1.548,0,0,0,1.544-1.544V483.1a1.548,1.548,0,0,0-1.544-1.544Z"
          transform="translate(-909 -481.2)"
          fill="#15173f"
        />
      </g>
    </g>
    <g id="Man" transform="translate(78.541)">
      <path
        id="Path_569"
        data-name="Path 569"
        d="M691.547,678.8l-.807,3.853-.014.028-.836,3.952-6.29-.326.453-2.635.057-.312.793-4.561Z"
        transform="translate(-674.491 -585.133)"
        fill="#fff"
      />
      <path
        id="Path_570"
        data-name="Path 570"
        d="M694.294,678.8l-.807,3.853-6.686,1.02.057-.312.793-4.561Z"
        transform="translate(-677.238 -585.133)"
        fill="#2f0128"
      />
      <path
        id="Path_571"
        data-name="Path 571"
        d="M726.174,391.028l-3.952-3.612s-24.167-.5-27.3,4.434-7.3,16.588-12.225,39.933l9.222.822s6.87-24.238,12.041-34.508l22.212-7.069Z"
        transform="translate(-673.718 -335.014)"
      />
      <path
        id="Path_572"
        data-name="Path 572"
        d="M892.092,692.338l-5.425.354-.949-3.216L884.4,685l7,.694.2,1.955Z"
        transform="translate(-846.846 -590.455)"
        fill="#fff"
      />
      <path
        id="Path_573"
        data-name="Path 573"
        d="M964.008,32.855l.85,6.559-6.559-.2.312-2.507.255-2h0a4.331,4.331,0,0,1-3.711-2.422c-.878-2.182-1.572-11.786,2.847-13.2,0,0,6.7-1.048,8.131,4.221.014-.014,1.02,3.7-2.125,9.548Z"
        transform="translate(-907.019 -16.309)"
        fill="#f2c8da"
      />
      <path
        id="Path_574"
        data-name="Path 574"
        d="M891.6,687.649l-5.879,1.827L884.4,685l7,.694Z"
        transform="translate(-846.846 -590.455)"
        fill="#2f0128"
      />
      <path
        id="Path_575"
        data-name="Path 575"
        d="M822.272,399.855s24.988,3.329,24.11-8.556c-.227-3,5.4-6.814-8.244-5.666,0,0-23.756.907-26.716,7.479,0,0-2.961,6.573,2.139,17.92l7.395,19.69,8.882-.354-7.564-30.513Z"
        transform="translate(-783.472 -333.316)"
      />
      <path
        id="Path_576"
        data-name="Path 576"
        d="M972.289,107.7s-1.9,2.691-2.989.283Z"
        transform="translate(-919.72 -92.444)"
        fill="#07012d"
      />
      <path
        id="Path_577"
        data-name="Path 577"
        d="M948.775,13.982s.793-1.218.992-1.643c.793-1.714,2.139-6.091-.085-6.233,0,0,1.077-4.788-5.085-4.292,0,0-1.9-.992-2.054-1.813a1.516,1.516,0,0,0,.992,1.643s-6.4-3.131-4.845,1.218c0,0-3.995-.212-3.131,3.612,0,0,.694,2.267,5.043,1.742a6.351,6.351,0,0,1-3.655.17s1.742,1.558,5.907-.354c0,0,.354,1.742,3.131,1.048l.17,2.592s.992-1.969,2.295-1.147c.765.482,1.147,1.317.326,3.456Z"
        transform="translate(-890.653 0)"
        fill="#050044"
      />
      <path
        id="Path_578"
        data-name="Path 578"
        d="M751.249,228l-4.193,6.3-12.778,5.241-1.912-.354a3.514,3.514,0,0,0-1.757.071c-1.162.382-4.59,1.742-4.59,1.742A1.732,1.732,0,0,0,725,242h12.069l12.636-1.742a5.136,5.136,0,0,0,3.825-2.649l3.485-6.46L751.249,228Z"
        transform="translate(-710.026 -196.53)"
        fill="#f2c8da"
      />
      <path
        id="Path_579"
        data-name="Path 579"
        d="M925.064,157.38A16,16,0,0,0,913.93,144.9a3.173,3.173,0,0,1-3.23,2.04c-2.777.128-2.72-1.827-2.72-1.827-2,.51-4.774,1.162-6.36,2.819-3.9,4.066-6.12,10.5-6.12,10.5l5.6,3.853-1.233,16.9,19.889,7.395a161.927,161.927,0,0,0,2.791-19.889,43.24,43.24,0,0,0,.028-8.783l2.493-.524Z"
        transform="translate(-856.374 -125.11)"
        fill="#00a1aa"
      />
      <path
        id="Path_580"
        data-name="Path 580"
        d="M927.555,236.713l-1.572-5.6.028-.014,6.006-1.3c.227.637.439,1.332.652,2.068.765,2.72,1.346,5.808,1.672,7.069a3.074,3.074,0,0,1-.765,2.918c-.085.085-.17.17-.255.241a1.959,1.959,0,0,1-1.247.51l-18.925.581a11.627,11.627,0,0,1-4.236.354c-1.4,0-5.213-.014-5.213-.014l7.1-2.776Z"
        transform="translate(-863.412 -198.08)"
        fill="#f2c8da"
      />
      <path
        id="Path_581"
        data-name="Path 581"
        d="M839.8,724.251l.142,1.544a1.134,1.134,0,0,1-.779,1.176l-6.686,2.224a1.122,1.122,0,0,0-.779,1.062,1.214,1.214,0,0,0,1.162,1.133l14.647.113a1.141,1.141,0,0,0,1.133-1.3l-.949-6.445a1.128,1.128,0,0,0-1.176-.963l-5.638.241a1.112,1.112,0,0,0-1.077,1.218Z"
        transform="translate(-801.609 -622.892)"
        fill="#404042"
      />
      <path
        id="Path_582"
        data-name="Path 582"
        d="M626.239,727.085l-6.162,2.224a1.122,1.122,0,0,0-.779,1.063,1.217,1.217,0,0,0,.383.807,1.106,1.106,0,0,0,.779.326l12.721.1a1.141,1.141,0,0,0,1.133-1.3l.963-6.445a1.128,1.128,0,0,0-1.176-.963l-5.638.255c-.623.028-1.884,3.825-2.224,3.938Z"
        transform="translate(-619.297 -622.978)"
        fill="#404042"
      />
      <path
        id="Path_583"
        data-name="Path 583"
        d="M987.382,121.8a5.465,5.465,0,0,1-3.782,3.131l.255-2a7.883,7.883,0,0,0,3.527-1.133Z"
        transform="translate(-931.994 -104.546)"
        fill="#2f0128"
      />
      <path
        id="Path_584"
        data-name="Path 584"
        d="M1067.858,231.968l-6.658-.765,6.006-1.3c.227.623.439,1.332.652,2.068Z"
        transform="translate(-998.601 -198.077)"
        fill="#2f0128"
      />
      <path
        id="Path_585"
        data-name="Path 585"
        d="M809.094,410.947c-.1-.411-2.521-10,.977-12.721,3-2.337,10.908-5.071,15.4-5.326l.014.354c-4.434.255-12.239,2.946-15.2,5.255-3.315,2.578-.878,12.268-.85,12.367Z"
        transform="translate(-781.428 -338.732)"
        fill="#fff"
      />
      <rect
        id="Rectangle_411"
        data-name="Rectangle 411"
        width="0.354"
        height="10.681"
        transform="translate(60.993 28.492) rotate(-15.308)"
        fill="#020019"
      />
    </g>
    <g id="Chair-2" transform="translate(69.653 65.59)">
      <path
        id="Path_586"
        data-name="Path 586"
        d="M570.811,541.964h-6.332v-7.692h5.156a.792.792,0,0,0,.793-.793v-.17a.792.792,0,0,0-.793-.793h-5.156V504h-2.1v28.516h-5.156a.792.792,0,0,0-.793.793v.17a.792.792,0,0,0,.793.793h5.156v7.692H556.05a.852.852,0,0,0-.85.85v.057a.852.852,0,0,0,.85.85h14.761a.852.852,0,0,0,.85-.85v-.057a.852.852,0,0,0-.85-.85Z"
        transform="translate(-551.701 -500.685)"
        fill="#0076a5"
      />
      <g id="Group_697" data-name="Group 697" transform="translate(0 0)">
        <path
          id="Path_587"
          data-name="Path 587"
          d="M533.514,481.8h19.478a1.711,1.711,0,0,1,1.714,1.714v.227a1.711,1.711,0,0,1-1.714,1.714H533.514a1.711,1.711,0,0,1-1.714-1.714v-.213A1.714,1.714,0,0,1,533.514,481.8Z"
          transform="translate(-531.616 -481.63)"
          fill="#fff"
        />
        <path
          id="Path_588"
          data-name="Path 588"
          d="M551.876,484.623H532.4a1.9,1.9,0,0,1-1.9-1.9V482.5a1.9,1.9,0,0,1,1.9-1.9h19.478a1.9,1.9,0,0,1,1.9,1.9v.227A1.9,1.9,0,0,1,551.876,484.623ZM532.4,480.954a1.548,1.548,0,0,0-1.544,1.544v.227a1.548,1.548,0,0,0,1.544,1.544h19.478a1.548,1.548,0,0,0,1.544-1.544V482.5a1.548,1.548,0,0,0-1.544-1.544Z"
          transform="translate(-530.5 -480.6)"
          fill="#15173f"
        />
      </g>
    </g>
    <g id="Woman" transform="translate(55.297 6.636)">
      <path
        id="Path_589"
        data-name="Path 589"
        d="M454.548,515.75,450,516.1l-7.819-25.272-.581-1.841,6.743-7.791,2.252,12.523Z"
        transform="translate(-439.164 -422.16)"
        fill="#f3c9db"
      />
      <path
        id="Path_590"
        data-name="Path 590"
        d="M450.6,493.723l-8.414-2.89-.581-1.841,6.743-7.791Z"
        transform="translate(-439.164 -421.336)"
        fill="#2f0128"
      />
      <path
        id="Path_591"
        data-name="Path 591"
        d="M501.869,559.191h-4.547l-6.842-25.47-.68-2.521,8.216.354.737,5.284Z"
        transform="translate(-480.536 -465.078)"
        fill="#f3c9db"
      />
      <path
        id="Path_592"
        data-name="Path 592"
        d="M498.753,536.838l-8.273-3.116-.68-2.521,8.216.354Z"
        transform="translate(-480.536 -464.316)"
        fill="#2f0128"
      />
      <path
        id="Path_593"
        data-name="Path 593"
        d="M456.322,337.9l-1.4,7.168-14.35,5.241s-2.621.878-2.975,6.3c0,0-.269,6.743-.085,11.106h3.173l.935-5.156.878,5.156h11.46l.354-8.046,11.545-1.218s7.168-.878,7.352-7.876a45.335,45.335,0,0,0-3.853-12.593l-13.032-.085Z"
        transform="translate(-435.597 -298.044)"
        fill="#00a1aa"
      />
      <path
        id="Path_594"
        data-name="Path 594"
        d="M532.584,56.018S533.519,60.65,529.5,66c0,0,10.553-9.179-.652-17.155,0,0-3.626-4.306-9.562-.3A5.345,5.345,0,0,0,517,52.065c-.312,1.842-.241,4.746,1.487,8.769,0,0-4.915-.737-9.179,5.525,0,0-2.762,3.811-3.91,4.632a29.01,29.01,0,0,0,5.27-5.128,21.256,21.256,0,0,1,4.065-3.244s-6.389,6.12-7.961,9.633c0,0,3.017,13.755,11.758,13.188l10.143-20.583s4.462-3.626,3.91-8.839Z"
        transform="translate(-493.926 -46.845)"
        fill="#050044"
      />
      <path
        id="Path_595"
        data-name="Path 595"
        d="M607.127,83.431l.1-4.915s4.731-.142,2.946-10.511L602.4,66.8l-2.2,7.621,1.87,2.791s-.156,4.406-.113,6.5Z"
        transform="translate(-575.297 -63.973)"
        fill="#f3c9db"
      />
      <path
        id="Path_596"
        data-name="Path 596"
        d="M442.235,253.3l-1.218,5.071-9.448,3.683-.864-.312a2.949,2.949,0,0,0-1.643-.113l-3.471,1.091a2.065,2.065,0,0,0-.836.637l-.354.453h19.761l4.547-8.57-6.474-1.941Z"
        transform="translate(-424.4 -224.829)"
        fill="#f3c9db"
      />
      <path
        id="Path_597"
        data-name="Path 597"
        d="M569,188.641l-5.425-.354.354,10.667h-14v-9.973l-3.329-.694a48.758,48.758,0,0,1,1.4-9.619s.524-1.048,8.046-3.414a3.5,3.5,0,0,0,5.071-.354l6.474,2.89a3.233,3.233,0,0,1,1.4,2.451c.184,1.757,0,8.4,0,8.4Z"
        transform="translate(-529.289 -157.321)"
        fill="#00a1aa"
      />
      <path
        id="Path_598"
        data-name="Path 598"
        d="M532.251,275.556H504.6l.113-.283A5.389,5.389,0,0,1,507.107,274l1.289-.34a7.006,7.006,0,0,1,1.53-.227l2.026-.142a8.719,8.719,0,0,0,2.975.354c1.232-.17,12.593-2.507,12.593-2.507V267l5.425.368s.071.878.1,2.068c.057,2.111-.014,5.227-.793,6.12Z"
        transform="translate(-493.239 -236.623)"
        fill="#f3c9db"
      />
      <path
        id="Path_599"
        data-name="Path 599"
        d="M592.975,69.97s5.043-.524,5.751-5.525L589.872,63l-1.941,8.471,1.742,3.159s1.757,2.536-3.074,3.4c0,0,4.845.907,5.34-4.434l-.836-2.9a1.848,1.848,0,0,1-1.317-2.507s.453-.751,1.586.014a6.788,6.788,0,0,0,5.893-2.55,6.613,6.613,0,0,1-4.292,4.321Z"
        transform="translate(-563.623 -60.711)"
        fill="#050044"
      />
      <path
        id="Path_600"
        data-name="Path 600"
        d="M440.9,724.551l.142,1.544a1.134,1.134,0,0,1-.779,1.176l-6.686,2.224a1.123,1.123,0,0,0-.779,1.062,1.214,1.214,0,0,0,1.162,1.133l14.647.113a1.141,1.141,0,0,0,1.133-1.3l-.949-6.445a1.128,1.128,0,0,0-1.176-.963l-5.638.241a1.119,1.119,0,0,0-1.077,1.218Z"
        transform="translate(-431.607 -629.785)"
        fill="#5e1241"
      />
      <path
        id="Path_601"
        data-name="Path 601"
        d="M476.7,724.551l.142,1.544a1.134,1.134,0,0,1-.779,1.176l-6.686,2.224a1.123,1.123,0,0,0-.779,1.062,1.214,1.214,0,0,0,1.162,1.133l14.647.113a1.141,1.141,0,0,0,1.133-1.3l-.949-6.445a1.128,1.128,0,0,0-1.176-.963l-5.638.241A1.119,1.119,0,0,0,476.7,724.551Z"
        transform="translate(-462.336 -629.785)"
        fill="#991e66"
      />
      <path
        id="Path_602"
        data-name="Path 602"
        d="M671.925,269.337l-5.525-2.394V266.9l5.425.368c.014,0,.071.878.1,2.068Z"
        transform="translate(-632.119 -236.488)"
        fill="#2f0128"
      />
      <g id="Group_698" data-name="Group 698" transform="translate(14.591 40.469)">
        <path
          id="Path_603"
          data-name="Path 603"
          d="M636.711,343.235c-.255-.482-.411-.765-.411-.765l.3-.17s.17.3.425.779Z"
          transform="translate(-620.873 -342.3)"
          fill="#fff"
        />
        <path
          id="Path_604"
          data-name="Path 604"
          d="M527.754,383.267H527.4v-1.8h.354Zm0-3.612H527.4v-1.8h.354Zm.1-3.541-.34-.085a3.768,3.768,0,0,1,.907-1.643l.255.241a3.356,3.356,0,0,0-.822,1.487Zm2.252-2.38-.1-.34a3.382,3.382,0,0,1,.637-.127c.368-.043.765-.1,1.176-.156l.043.354c-.411.057-.807.113-1.176.156-.2.028-.383.071-.581.113Zm3.541-.552-.057-.34c.595-.1,1.176-.212,1.771-.326l.071.34C534.837,372.968,534.242,373.082,533.647,373.181Zm3.542-.708-.071-.34c.595-.142,1.19-.283,1.742-.425l.085.34C538.393,372.2,537.8,372.345,537.189,372.472Zm3.5-.907-.1-.34q.914-.276,1.7-.552l.113.326c-.51.184-1.091.382-1.714.567Zm3.414-1.247-.142-.312a8.278,8.278,0,0,0,1.516-.878l.213.269A8.567,8.567,0,0,1,544.1,370.319Zm2.578-2.522-.34-.071a4.067,4.067,0,0,0,.085-.864,6.178,6.178,0,0,0-.057-.864l.354-.042a7.126,7.126,0,0,1,.057.921,6.114,6.114,0,0,1-.1.921Zm-.68-3.556c-.142-.524-.326-1.1-.552-1.7l.326-.113c.227.609.411,1.19.552,1.728l-.326.085Zm-1.2-3.357c-.227-.524-.482-1.077-.737-1.629l.312-.156c.269.567.524,1.119.751,1.643l-.326.142Z"
          transform="translate(-527.4 -356.72)"
          fill="#15173f"
        />
        <rect
          id="Rectangle_412"
          data-name="Rectangle 412"
          width="0.354"
          height="0.878"
          transform="translate(0.014 28.331)"
          fill="#15173f"
        />
      </g>
      <rect
        id="Rectangle_413"
        data-name="Rectangle 413"
        width="10.497"
        height="0.354"
        transform="translate(34.025 34.628) rotate(-89.05)"
        fill="#020019"
      />
    </g>
    <g id="Table" transform="translate(14.191 43.634)">
      <rect
        id="Rectangle_414"
        data-name="Rectangle 414"
        width="4.377"
        height="61.578"
        transform="translate(20.809 3.315)"
        fill="#708999"
      />
      <rect
        id="Rectangle_415"
        data-name="Rectangle 415"
        width="4.377"
        height="61.578"
        transform="translate(103.389 3.315)"
        fill="#708999"
      />
      <g id="Group_699" data-name="Group 699" transform="translate(0 0)">
        <rect
          id="Rectangle_416"
          data-name="Rectangle 416"
          width="129.418"
          height="4.377"
          transform="translate(0.17 0.17)"
          fill="#708999"
        />
        <path
          id="Path_605"
          data-name="Path 605"
          d="M229.972,330.317H100.2V325.6H229.972v4.717Zm-129.441-.34H229.613v-4.023H100.532v4.023Z"
          transform="translate(-100.2 -325.6)"
          fill="#15173f"
        />
      </g>
    </g>
    <g id="Woman-2" transform="translate(14.453 5.075)">
      <path
        id="Path_606"
        data-name="Path 606"
        d="M119.681,225.458l-.354,3.584-10.383-.878a2.976,2.976,0,0,1-2.663-3.6c.482-2.224,1.034-4.958,1.162-6.2.042-.382.028-.623-.028-.652l1.247-2.309,3.641,1.133.992.312-1.842,6.814,8.23,1.8Z"
        transform="translate(-105.622 -190.648)"
        fill="#f3c9db"
      />
      <path
        id="Path_607"
        data-name="Path 607"
        d="M198.858,78.286c-1.232.156-3.1.368-3.881.368H179.932l-1.232-3.7-.453-1.374-1.615-4.845-.892-2.691-8.839-5.51,2.2-7.1L176.519,37.8s4.023.524,3.853,9.449c0,0,.354,6.12-4.717,4.717l-1.317,4.462.312.227L178.36,59.4a4.443,4.443,0,0,1,2.1,3.329l1.162,4.391,1.147,4.335v.014l.836,3.159,9.619,2.1"
        transform="translate(-157.714 -37.52)"
        fill="#f3c9db"
      />
      <path
        id="Path_608"
        data-name="Path 608"
        d="M323.88,693.105l-4.59,1.02-.666-3.853-.425-2.479,4.306-.793.467,2.068Z"
        transform="translate(-287.581 -597.246)"
        fill="#f3c9db"
      />
      <path
        id="Path_609"
        data-name="Path 609"
        d="M322.974,689.068l-4.349,1.2-.425-2.479,4.306-.793Z"
        transform="translate(-287.581 -597.246)"
        fill="#2f0128"
      />
      <path
        id="Path_610"
        data-name="Path 610"
        d="M167.5,453.029l16.092,12.423,4.377,19.761s6.12.17,6.12,0-3.329-23.968-3.329-23.968L188.494,449.7,167.5,453.029Z"
        transform="translate(-158.229 -393.561)"
        fill="#29324c"
      />
      <path
        id="Path_611"
        data-name="Path 611"
        d="M119.6,216.533l-.921,4.59-3.952-2.762c.043-.382.028-.623-.028-.652l1.247-2.309,3.655,1.133Z"
        transform="translate(-112.908 -190.594)"
        fill="#2f0128"
      />
      <path
        id="Path_612"
        data-name="Path 612"
        d="M236.8,613l-2.791,5.6-4.207-2.1,2.167-3.853.992-1.742Z"
        transform="translate(-211.704 -531.501)"
        fill="#f3c9db"
      />
      <path
        id="Path_613"
        data-name="Path 613"
        d="M249.93,613l-1.742,3.5-3.088-3.853.992-1.742Z"
        transform="translate(-224.836 -531.458)"
        fill="#2f0128"
      />
      <path
        id="Path_614"
        data-name="Path 614"
        d="M241.734,249.063c-1.2,1.048-3.1,2.691-4.066,3.485l-.453-1.374-1.615-4.845,4.986-1.629,1.147,4.335v.028Z"
        transform="translate(-216.682 -215.862)"
        fill="#2f0128"
      />
      <path
        id="Path_615"
        data-name="Path 615"
        d="M128.109,382.244a46,46,0,0,1-6.12-3.853,193.86,193.86,0,0,1,8.924-19.591H106.946c-6.828-.354-4.9-9.973-3.669-12.593.751-1.615,1.643-4.179,2.21-5.893.354-1.062.581-1.813.581-1.813l12.239,2.1.907,2.819,1.19,3.655c21.164,3.329,19.775,6.3,19.775,6.3.708,5.255-12.069,28.87-12.069,28.87Z"
        transform="translate(-102.052 -297.34)"
        fill="#323b5b"
      />
      <path
        id="Path_616"
        data-name="Path 616"
        d="M140.041,343.416l-13.741-3.1c.354-1.062.581-1.813.581-1.813l12.239,2.1.921,2.819Z"
        transform="translate(-122.865 -296.68)"
        fill="#2f0128"
      />
      <path
        id="Path_617"
        data-name="Path 617"
        d="M137.273,178.493l-2.309-8.726a4.443,4.443,0,0,0-2.1-3.329l-3.881-2.918c-1.969.212-4.292.793-5.992-1.02a19.372,19.372,0,0,0-4.023.694c-3.06.765-5.071,9.619-5.071,9.619l2.1.524.085,10.043-.694,5.794,13.3.878-.085-9.364a5.359,5.359,0,0,0,1.757-4.193c-.071-.34,1.374,4.122,1.374,4.122,1.077-.552,4.037-1.431,5.539-2.125Z"
        transform="translate(-112.222 -145.125)"
        fill="#00a1aa"
      />
      <path
        id="Path_618"
        data-name="Path 618"
        d="M137.329,38.554a9.148,9.148,0,0,0-1.629,2.139l-.014.014c-1.714,1.827-4.561,6.771-2,10.228a7.486,7.486,0,0,1,.567-6.828c-.751,2.521-.907,5.043-.255,6.176,1.218,2.1,3.5,1.757,7.876,1.4s5.255-9.973,5.255-9.973l4.547-.354c-2.451-8.23-11.375-5.6-14.35-2.8Z"
        transform="translate(-128.327 -35.823)"
        fill="#050044"
      />
      <path
        id="Path_619"
        data-name="Path 619"
        d="M316.9,723.55l-.142,1.53a1.122,1.122,0,0,0,.765,1.176l6.658,2.281a1.127,1.127,0,0,1,.765,1.077,1.216,1.216,0,0,1-.382.807,1.163,1.163,0,0,1-.793.312l-14.647-.028a1.13,1.13,0,0,1-1.119-1.3l1.02-6.445a1.14,1.14,0,0,1,1.176-.963l5.624.3a1.156,1.156,0,0,1,1.077,1.261Z"
        transform="translate(-278.82 -627.28)"
        fill="#15173f"
      />
      <path
        id="Path_620"
        data-name="Path 620"
        d="M206.934,646.457l-.907,1.246a1.129,1.129,0,0,0,.057,1.4l4.6,5.34a1.11,1.11,0,0,1,.113,1.318,1.22,1.22,0,0,1-.737.5,1.086,1.086,0,0,1-.836-.127l-12.622-7.409a1.132,1.132,0,0,1-.3-1.7l4.122-5.057a1.124,1.124,0,0,1,1.5-.227l4.7,3.1a1.124,1.124,0,0,1,.3,1.615Z"
        transform="translate(-182.732 -558.233)"
        fill="#15173f"
      />
    </g>
    <g id="Chair-3" transform="translate(13.398 65.59)">
      <path
        id="Path_621"
        data-name="Path 621"
        d="M134.811,541.964h-6.332v-7.692h5.156a.792.792,0,0,0,.793-.793v-.17a.792.792,0,0,0-.793-.793h-5.156V504h-2.1v28.516h-5.156a.792.792,0,0,0-.793.793v.17a.792.792,0,0,0,.793.793h5.156v7.692H120.05a.852.852,0,0,0-.85.85v.057a.852.852,0,0,0,.85.85H134.8a.852.852,0,0,0,.85-.85v-.057a.832.832,0,0,0-.836-.85Z"
        transform="translate(-115.715 -500.685)"
        fill="#0076a5"
      />
      <g id="Group_700" data-name="Group 700" transform="translate(0 0)">
        <path
          id="Path_622"
          data-name="Path 622"
          d="M97.613,481.8h19.478a1.711,1.711,0,0,1,1.714,1.714v.227a1.711,1.711,0,0,1-1.714,1.714H97.613a1.711,1.711,0,0,1-1.714-1.714v-.213A1.705,1.705,0,0,1,97.613,481.8Z"
          transform="translate(-95.715 -481.63)"
          fill="#fff"
        />
        <path
          id="Path_623"
          data-name="Path 623"
          d="M115.976,484.623H96.5a1.9,1.9,0,0,1-1.9-1.9V482.5a1.9,1.9,0,0,1,1.9-1.9h19.478a1.9,1.9,0,0,1,1.9,1.9v.227a1.9,1.9,0,0,1-1.9,1.9ZM96.5,480.954a1.548,1.548,0,0,0-1.544,1.544v.227a1.548,1.548,0,0,0,1.544,1.544h19.478a1.548,1.548,0,0,0,1.544-1.544V482.5a1.548,1.548,0,0,0-1.544-1.544Z"
          transform="translate(-94.6 -480.6)"
          fill="#15173f"
        />
      </g>
    </g>
    <g id="Group_701" data-name="Group 701" transform="translate(145.718 29.999)">
      <path
        id="Path_624"
        data-name="Path 624"
        d="M1282.621,458.474l8.927-5.739a29.456,29.456,0,0,0,4.8-11.438,30.414,30.414,0,0,0,.359-3.268l-3.766.08,3.746-3.647a42.765,42.765,0,0,0-1.794-9.6,43.792,43.792,0,0,0-5.32-11.657,115.9,115.9,0,0,0-11.438,10.9c-.12.139-.239.259-.359.4l.478,5.181-2.112-3.288c-3.746,4.484-6.974,9.445-8.589,15.045a29.822,29.822,0,0,0-.8,3.647l3.886,8.07-4.245-1.933c.239,6.895,2.471,13.69,5.42,19.987,3.746-2.252,12.574-10.1,14.906-12.534.777-.8,1.514-1.634,2.232-2.491l-6.337,2.292Z"
        transform="translate(-1242.428 -409.972)"
        fill="#00a1aa"
      />
      <line
        id="Line_172"
        data-name="Line 172"
        y1="41.309"
        x2="12.873"
        transform="translate(29.472 20.007)"
        fill="none"
        stroke="#fff"
        stroke-width="1"
        opacity="0.36"
      />
      <path
        id="Path_625"
        data-name="Path 625"
        d="M1222.5,441.8l6.337-8.509a29.568,29.568,0,0,0,.458-12.395,24.966,24.966,0,0,0-.817-3.188l-3.507,1.395,2.212-4.723A46.427,46.427,0,0,0,1213.036,397a113.832,113.832,0,0,0-6.855,14.228,5.162,5.162,0,0,1-.2.5l2.272,4.683-3.128-2.332c-1.933,5.52-3.209,11.3-2.73,17.1a27.822,27.822,0,0,0,.538,3.687l6.476,6.177-4.643-.319c2.65,6.357,7.154,11.936,12.116,16.8,2.71-3.427,8.21-13.889,9.525-16.978.438-1.016.837-2.072,1.216-3.129L1222.5,441.8Z"
        transform="translate(-1191.096 -397)"
        fill="#5cc2c9"
      />
      <line
        id="Line_173"
        data-name="Line 173"
        x1="2.531"
        y1="43.202"
        transform="translate(23.374 17.376)"
        fill="none"
        stroke="#fff"
        stroke-width="1"
        opacity="0.36"
      />
      <path
        id="Path_626"
        data-name="Path 626"
        d="M1157.718,497.8l-7.353-4.723a22.641,22.641,0,0,1-4.264-12.116l3.109.06-3.089-3.009a35.733,35.733,0,0,1,1.475-7.911,36.125,36.125,0,0,1,4.384-9.6,95.565,95.565,0,0,1,9.426,8.987c.1.1.2.219.3.339l-.379,4.264,1.734-2.71a34.41,34.41,0,0,1,7.074,12.395,26.181,26.181,0,0,1,.657,3.009l-3.208,6.656,3.487-1.594c-.2,5.679-2.052,11.279-4.464,16.46-3.089-1.853-10.362-8.329-12.295-10.322-.638-.658-1.255-1.355-1.833-2.053l5.241,1.873Z"
        transform="translate(-1146.1 -447.846)"
        fill="#00a1aa"
      />
      <line
        id="Line_174"
        data-name="Line 174"
        x1="10.601"
        y1="34.055"
        transform="translate(9.844 26.463)"
        fill="none"
        stroke="#fff"
        stroke-width="1"
        opacity="0.36"
      />
      <path
        id="Path_627"
        data-name="Path 627"
        d="M1236.369,668.6l-2.411,24.769h-19.967L1211.6,668.6Z"
        transform="translate(-1198.547 -614.478)"
        fill="#141449"
      />
      <path
        id="Path_628"
        data-name="Path 628"
        d="M1261.192,668.6l-2.411,24.769h-13.77L1242.6,668.6Z"
        transform="translate(-1223.37 -614.478)"
        fill="#267476"
      />
      <path
        id="Path_629"
        data-name="Path 629"
        d="M1220.188,693.369h-6.2L1211.6,668.6h6.177Z"
        transform="translate(-1198.547 -614.478)"
        opacity="0.91"
      />
    </g>
  </svg>
</template>
